export enum EComplaintUrl {
  COMPLAINTS = 'complaints',
}
